import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = [{
  title: 'The Sovereign Bunker',
  description: 'How to claim an area where her "jurisdiction" ends.'
}, {
  title: 'The 15-Minute Briefing',
  description: 'How to handle all household friction in one tiny window so the rest of your day is yours.'
}, {
  title: 'The "Visitor" Rule',
  description: 'The simple psychological flip that stops micro-management in its tracks.'
}, {
  title: 'The 14-Day Calendar',
  description: 'A step-by-step rollout to install peace without a single "talk about our relationship" session.'
}];
export function RevealSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg-alt border-b border-brand-card" data-id="element-131">
      <div className="max-w-6xl mx-auto" data-id="element-132">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-134">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-10" data-id="element-135">
              In this 60-page tactical playbook, you’ll discover:
            </h2>

            <div className="space-y-6" data-id="element-136">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start p-6 bg-brand-bg rounded-lg border-l-4 border-brand-accent shadow-sm hover:bg-brand-card transition-colors" data-id="element-137">
                  <CheckCircle2 className="w-6 h-6 text-brand-accent mt-1 mr-4 flex-shrink-0" data-id="element-138" />
                  <div data-id="element-139">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-140">
                      {feature.title}
                    </h3>
                    <p className="text-brand-text-muted" data-id="element-141">
                      {feature.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2 flex justify-center" data-id="element-142">
            <div className="relative" data-id="element-143">
              <div className="absolute inset-0 bg-brand-accent/20 blur-[60px] rounded-full opacity-40" data-id="element-144" />
              <img src="https://cdn.magicpatterns.com/uploads/a3qNzLvMSBEYwcS9FxZVPe/heylloyd-image-1771301560299.png" alt="Home-All-Day Reset Playbook" className="relative w-full max-w-sm rounded-lg shadow-2xl border border-brand-card/50 rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-145" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}